const angular = require('angular');
const app = angular.module('learn-services');
app.factory('Intercom', ['Access','appConfiguration', 'Navigation', 'Storage', '$timeout', '$window', function(Access, appConfiguration, Navigation, Storage, $timeout, $window) {
    var self = this;
    self.intercom = {
      timeConvert: function(date) {
        var date = new Date(date).valueOf();
        return parseInt(date.toString().slice(0, -3));
      },
      bootUser: function() {
        if (self.intercom.booted) {
          return;
        }
        var app_id = appConfiguration.intercomAppId;
        var url = Navigation.getUrl();
        let token = null;
        if (Access.authtoken) {
          token = Access.authtoken;
        } else {
          token = Storage.get('authtoken');
          if (token) {
            Access.setAuthtoken(Storage.get('authtoken'));
            Access.sync = true;
          }
        }
        var company = token.company;
        var user = token.user;
        if (!user.email) {
          return;
        }

        // Set Google Analytics
        if (company && company.google_analytics) {
          window.ga = window.ga || function() {
            (ga.q = ga.q || []).push(arguments)
          };
          ga.l = +new Date;
          ga('create', company.google_analytics, 'auto');
        }
        // End Google Analytics

        if (!user || !user.first_name || !company || !company.name) {
          return;
        }
        var created = user.first_login || user.createdAt || user.created_at;

        $window.Intercom && $window.Intercom('boot', {
          app_id: app_id,
          user_id: user._id,
          name: user.first_name + ' ' + user.last_name,
          email: user.email,
          created_at: self.intercom.timeConvert(created),
          role: user.role,
          department: user.department,
          is_manager: user.is_manager ? true : false,
          manager_email: user.manager_email ? user.manager_email : '',
          has_avatar: user.image ? true : false,
          banner_image: user.banner_image ? true : false,
          about: user.about ? true : false,
          skills: user.skills && user.skills.length ? true : false,
          company: {
            id: company._id,
            name: company.name,
            created_at: self.intercom.timeConvert(company.createdAt)
          },
          widget: {
            activator: "#IntercomDefaultWidget"
          },
          hide_default_launcher: true
        });
        self.intercom.booted = true;
      },
      update: function() {
        $timeout(function() {
          $window.Intercom && $window.Intercom('update');
        }, 3);
      },
      shutdown: function() {
        if (!self.intercom.booted) {
          return;
        }
        $window.Intercom && $window.Intercom('shutdown');
        self.intercom.booted = false;
      },
      toggle: function() {
        if (self.intercom.toggleStatus === 'hidden') {
          $window.Intercom && $window.Intercom('show');
          self.intercom.toggleStatus = 'showing';
          return;
        }
        $window.Intercom && $window.Intercom('hide');
        self.intercom.toggleStatus = 'hidden';
      },
      booted: false,
      toggleStatus: 'hidden'
    };
    return self.intercom;
  }]);